export const styles = theme => ({
    tabs: {
        width: 'auto',
        display: 'block',
        padding: '10px 16px',
        [theme.breakpoints.up(650 + theme.spacing.unit * 2 * 2)]: {
            width: 650,
            marginLeft: 'auto',
            marginRight: 'auto',
            paddingTop: 25,
        }
    },
    main: {
        width: 'auto',
        display: 'block',
        marginLeft: theme.spacing.unit * 1,
        marginRight: theme.spacing.unit * 1,
        [theme.breakpoints.up(650 + theme.spacing.unit * 2 * 2)]: {
            width: 650,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    fab: {
        position: 'fixed',
        bottom: theme.spacing.unit * 1,
        right: theme.spacing.unit * 2,
        [theme.breakpoints.up('md')]: {
            bottom: theme.spacing.unit * 10,
            right: theme.spacing.unit * 15,
        },
    },
    avatar: {
        margin: theme.spacing.unit,
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%',
        marginTop: theme.spacing.unit,
    },
    register: {
        marginTop: theme.spacing.unit * 3,
    }
});
